var map = {
	"./board/corner-bottom-left.png": 441,
	"./board/corner-bottom-right.png": 442,
	"./board/corner-top-left.png": 443,
	"./board/corner-top-right.png": 444,
	"./board/hole.png": 445,
	"./board/plank-bottom.png": 446,
	"./board/plank-left.png": 447,
	"./board/plank-right.png": 448,
	"./board/plank-top.png": 449,
	"./buttons/button-large-border.png": 450,
	"./buttons/button-medium-border.png": 451,
	"./buttons/button-nav-border.png": 452,
	"./flag/flag-normal.png": 453,
	"./flag/flag-ripped.png": 454,
	"./gems/border-default.png": 455,
	"./gems/broken-shadow.png": 456,
	"./gems/gem-blue.png": 457,
	"./gems/gem-bronze.png": 458,
	"./gems/gem-caviar.png": 459,
	"./gems/gem-gold.png": 460,
	"./gems/gem-ice.png": 461,
	"./gems/gem-lava.png": 462,
	"./gems/gem-neutral.png": 463,
	"./gems/gem-red.png": 464,
	"./gems/gem-silver.png": 465,
	"./gems/gem-void.png": 466,
	"./logo.png": 467,
	"./logo/logo-full.png": 468,
	"./panel/panel-border-bottom.png": 469,
	"./panel/panel-border-left.png": 470,
	"./panel/panel-border-right.png": 471,
	"./panel/panel-border-top.png": 472,
	"./round-button/round-button-bg-pressed.png": 473,
	"./round-button/round-button-bg.png": 474
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 440;